import React from "react";

import styles from "../IndexRegistration.module.scss";
import { cookieHelpers } from "helpers/cookieHelpers";

export default function Step0() {
  const handleBack = () => {
    cookieHelpers.clearAllSessionData();
    window.location.href = "/";
  };

  return (
    <section className="pb-55">
      <div className={styles.indexContainer}>
        <img src="/img/new/2025/index.svg" alt="Index" className={styles.indexImage} />
        <p className={styles.infoText}>
          Transmiterea indexului este disponibila doar in perioada 19-26 a fiecarei luni.
        </p>
        <div className={styles.successButtonContainer}>
          <button type="button" onClick={handleBack} className="btn btn-danger">
            Inapoi
          </button>
        </div>
      </div>
    </section>
  );
}
